import React, { useEffect, useState } from 'react';

import { Home } from '@mui/icons-material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { getCenterlineSurveys } from './operations';
import { Button, PushNotificationsHeader, CenterlineSurveyTable, SubHeader, Footer } from '../../../components';
import './styles.scoped.css';
import pushNotificationsOptions from '../pushNotificationsOptions';

const CenterlineSurvey = () => {
  const navigate = useNavigate();
  const { statuses } = pushNotificationsOptions;
  const [form, setForm] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const nextToken = null;
  let prevToken = null;
  dayjs.extend(utc);

  const formFilters = () => {
    const filters = {};

    if (form) {
      filters.subject = { eq: 'Driver Survey' };
    }

    if (form?.createdAtStartDate && form?.createdAtEndDate) {
      const startDate = dayjs(form?.createdAtStartDate).startOf('day').toISOString();
      // Set the end date to the end of the day
      const endDate = dayjs(form?.createdAtEndDate).endOf('day').toISOString();
      filters.createdAt = { between: [`${dayjs.utc(startDate).format()}`, `${dayjs.utc(endDate).format()}`] };
    }

    return filters;
  };

  const getFilteredNotifications = async token => {
    const filters = formFilters();
    const response = await getCenterlineSurveys(filters, token);

    return {
      list: response?.items,
      tokenResult: response?.nextToken,
    };
  };

  const getBatch = async (nextT = undefined) => {
    if (prevToken !== nextT) {
      prevToken = nextT;

      const response = await getFilteredNotifications(nextT);
      const items = response?.list;
      const token = response?.tokenResult;

      if (token !== null) {
        getBatch(token);
        if (items) {
          setNotifications([items, ...items]);
        }
      } else {
        setIsSearching(false);
      }
    }
  };

  const handleSearch = async () => {
    setIsSearching(true);
    const response = await getFilteredNotifications(nextToken);

    if (Array.isArray(response?.list) && response?.list.length > 0) {
      setNotifications([...(response?.list || [])]);
      setIsSearching(false);
    } else {
      getBatch(response?.tokenResult);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <>
      <SubHeader
        text="Push Notifications"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/push-notifications') },
        ]}
      />

      <div className="wrap">
        <PushNotificationsHeader
          form={form}
          setForm={setForm}
          setIsSearching={setIsSearching}
          setNotifications={setNotifications}
          route="add-centerline-survey"
          statuses={statuses}
          title="Centerline Survey"
          handleSearch={handleSearch}
          hideStatus
        />

        {Array.isArray(notifications) && !isSearching ? (
          <CenterlineSurveyTable data={notifications} />
        ) : (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        )}

        <Row className="justify-content-center">
          <Button
            variant="outline"
            onPress={() => {
              navigate('/push-notifications');
            }}
            text="Cancel"
          />
        </Row>
      </div>

      <Footer />
    </>
  );
};

export default CenterlineSurvey;
